import { render, staticRenderFns } from "./BriefStep.vue?vue&type=template&id=3139c5ca&scoped=true"
import script from "./BriefStep.vue?vue&type=script&lang=js"
export * from "./BriefStep.vue?vue&type=script&lang=js"
import style0 from "./BriefStep.vue?vue&type=style&index=0&id=3139c5ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3139c5ca",
  null
  
)

export default component.exports